<template>
    <div>
        <div class="background--paper p-1 divider--container">
            <div class="container mx-auto flex items-center justify-center pb-8">
                <div class="w-full text-center">
                    <div class="container mx-auto flex items-center justify-center px-2">
                        <faq-search label="Or try searching with some keywords..."/>
                    </div>
                </div>
            </div>
        </div>

        <div class="md:w-1/2 mx-auto text-center py-2">
            <p class="leading-snug" v-text="$t('FAQ_SEARCH_FOOTER_FEEL_FREE')"></p>
        </div>
    </div>
</template>

<script>
import FaqSearch from '@/components/partials/faq/FaqSearch';

export default {
    name: 'FaqSearchFooter',
    components: {
        FaqSearch,
    },
};
</script>
